import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Flex,
  Text,
  UnorderedList,
  ListItem,
} from "@chakra-ui/react";

// Types
import { Props } from "./Props.types";

// Components
import Alert from "components/Alert";

// Constants
import { TXN_ICONS } from "constants/transactions";
import { getDuration } from "utils/common";

const AllTransaction = ({
  isOpen,
  onClose,
  txnBatchData,
  handleTxView,
  onClear,
}: Props) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent w="440px" bg="brand.backgroundLight" m="1rem">
        <ModalHeader fontSize="1rem">All Transactions</ModalHeader>
        <ModalCloseButton
          _focus={{
            boxShadow: "none",
          }}
        />
        <ModalBody py="0" pb="1rem">
          <Alert type="info" withIcon={false} mt="1rem">
            <UnorderedList spacing={3} fontSize="14px" px="0.5rem">
              <ListItem>
                Your transactions history resets when you disconnect/switch your
                wallet.
              </ListItem>
            </UnorderedList>
          </Alert>
          {txnBatchData.length > 0 && (
            <Flex
              justifyContent="flex-end"
              alignItems="center"
              mt="1rem"
              pr="2px"
              bg="brand.backgroundLight"
              cursor="pointer"
            >
              <Text
                size="md"
                fontSize="14px"
                fontFamily="semi-bold"
                color="brand.primary"
                onClick={onClear}
              >
                Clear All
              </Text>
            </Flex>
          )}
          <TableContainer
            maxH="260px"
            overflowY="auto"
            fontSize="14px"
            mt="0.5rem"
            mb="1rem"
            p="1rem"
            bg="brand.background"
            borderRadius="8px"
          >
            <Table variant="simple">
              <Thead>
                <Tr fontSize="12px">
                  <Th ml="1rem">TIME</Th>
                  <Th>TYPE</Th>
                  <Th>AMOUNT</Th>
                  <Th pr="0" textAlign="right">
                    STATUS
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {txnBatchData.map((txn) => {
                  const { hash, amount, token, status, time, type } = txn;

                  return (
                    <Tr key={hash}>
                      <Td px="1rem">{getDuration(time, new Date())} ago</Td>
                      <Td>
                        <Text
                          color="brand.primary"
                          cursor="pointer"
                          onClick={() => handleTxView(hash)}
                        >
                          {type}
                        </Text>
                      </Td>
                      <Td>{amount ? `${amount} ${token}` : "-"}</Td>
                      <Td pr="0" textAlign="center">
                        {TXN_ICONS[status]}
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
            {txnBatchData.length === 0 && (
              <Flex
                width="100%"
                h="200px"
                justifyContent="center"
                alignItems="center"
              >
                You do not have any transactions
              </Flex>
            )}
          </TableContainer>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default AllTransaction;
